// extracted by mini-css-extract-plugin
export default {"corboxcon":"box_corboxcon__Y3soq","text1":"box_text1__WhHPh","symbol":"box_symbol__CL7TH","price":"box_price__-PVEP"};